import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseButton from 'src/common/components/base-button';
import CashierPreferencesHelper from 'src/common/helpers/cashier-preferences-helper';
import { ReactComponent as ReturnItemIcon } from 'src/common/media/return-item-icon-gray.svg';
import { stylesRewardsButtons } from './redeem-rewards-button-styles';

export const RedeemRewardsButtons = ({
  notNowHandler,
  partialHandler,
  allHandler,
  backHandler,
}: ProcessRedeemButtonsProps): JSX.Element => {
  const { t } = useTranslation();
  const styles = stylesRewardsButtons();
  const isLeftHanded = CashierPreferencesHelper.isLeftHanded();
  return (
    <>
      <Grid
        container
        style={{
          alignItems: 'center',
          justifyContent: 'space-between',
          alignSelf: 'stretch',
          paddingBottom: '1.82vh',
        }}
        direction='column'
      >
        <Grid
          container
          style={{ justifyContent: 'center' }}
          direction={isLeftHanded ? 'row-reverse' : 'row'}
        >
          {backHandler && (
            <Grid>
              <BaseButton
                buttonType='white'
                onClick={() => backHandler()}
                style={{ marginLeft: '2vh', marginRight: '2vh' }}
                data-testid='back-redeem-rewards-button'
              >
                <ReturnItemIcon className={styles.icon} />
                <Typography variant={'button'}>{t('Back')}</Typography>
              </BaseButton>
            </Grid>
          )}
          {notNowHandler && (
            <Grid>
              <BaseButton
                buttonType='white'
                onClick={() => notNowHandler()}
                style={{ marginLeft: '2vh', marginRight: '2vh' }}
                data-testid='not-now-redeem-rewards-button'
              >
                <Typography variant={'button'}>{t('NotNow')}</Typography>
              </BaseButton>
            </Grid>
          )}
          {partialHandler && (
            <Grid>
              <BaseButton
                buttonType='white'
                onClick={() => partialHandler()}
                style={{ marginLeft: '2vh', marginRight: '2vh' }}
                data-testid='partial-redeem-rewards-button'
              >
                <Typography variant={'button'}>{t('ApplyPartial')}</Typography>
              </BaseButton>
            </Grid>
          )}
          {allHandler && (
            <Grid>
              <BaseButton
                buttonType='primary'
                onClick={() => allHandler()}
                style={{ marginLeft: '2vh', marginRight: '2vh' }}
                data-testid='all-redeem-rewards-button'
              >
                <Typography variant={'button'}>{t('ApplyAll')}</Typography>
              </BaseButton>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export interface ProcessRedeemButtonsProps {
  notNowHandler?: () => void;
  partialHandler?: () => void;
  allHandler?: () => void;
  backHandler?: () => void;
}
